import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import * as Utilities from '../ts/Utilities';

import { ATTRIBUTE_SEPARATOR, IDataLoadEntityAttribute } from '../../../pdc-platform/src/ts/stores/EntityModelsStore';

import { ATTRIBUTE_TYPES } from './ConfigurationConstants';
import { IDisplayValue } from './Interfaces';

const ace: AceAjax.Ace = require('brace');

require('brace/mode/clojure'); //require('brace/mode/javascript');
require('brace/theme/xcode'); //require('brace/theme/chrome');
require('brace/theme/ambiance'); //require('brace/theme/ambiance');
require('../sass/code-field.sass');

//data of functions:
//import functionListStore from './libs/codeField_functionListStore';

interface IEditorItem {
    caption: string;
    meta: string;
    value: string;
    score: number;
    label?: string;
    description?: string;
    category?: string;
    returnType?: string;
    syntax?: string;
    docHTML?: string;
}

function getAttributeTypeDescription(itemType: string) {
    let result = Utilities.explainAttributeType(itemType);

    if (result === ATTRIBUTE_TYPES.ENUMERATION) {
        result = 'List';
    }

    return result;
}

function getDocTooltip(item: IEditorItem) {
    let docHTML = '';

    if (item.returnType != null) {
        if (docHTML.length > 0) {
            docHTML += '</br>';
        }

        docHTML += '<b>Returns: </b>' + item.returnType;
    }

    if (item.label != null && item.label !== '') {
        if (docHTML.length > 0) {
            docHTML += '</br>';
        }

        docHTML += '<b>Label: </b>' + item.label;
    }

    if (item.category != null) {
        if (docHTML.length > 0) {
            docHTML += '</br>';
        }

        docHTML += '<b>Category: </b>' + item.category;
    }

    if (item.syntax != null) {
        if (docHTML.length > 0) {
            docHTML += '</br>';
        }

        docHTML += '<b>Syntax: </b>' + item.syntax;
    }

    if (item.description != null) {
        if (docHTML.length > 0) {
            docHTML += '</br>';
        }

        docHTML += item.description;
    }

    item.docHTML = docHTML;
}

function surraundWithBrackets(value: string): string {
    //const startDelimiter0: string[] = [' ', ',', '(', '-', '+', '*', '%', '/', '^', '>', '<', '=', '['];
    const startDelimiter0: string[] = [' ', ',', '(', '-', '+', '*', '%', '/', '>', '<', '=', '['];
    //const startDelimiter1: string = ',(-+*%/^><= ';     // Symbols, which could be met before Attribute
    const startDelimiter1: string = ',(-+*%/><= '; // Symbols, which could be met before Attribute
    const len = startDelimiter1.length;

    let result = value;

    for (let i = 0; i < len; i++) {
        if (value.indexOf(startDelimiter0[i]) >= 0) {
            result = '[' + value + ']';
            break;
        }
    }

    return result;
}

function getAttributeEnvironment(line: string): string[] {
    let result: string[] = null;
    let strStart = '"';
    let strMiddle = '.';
    let strEnd = '",'; //'"attribute": "', strMiddle = '.', strEnd = '",';
    let lineMy = line;
    const num1 = lineMy.lastIndexOf(strStart);

    if (num1 >= 0) {
        //isAttrPath = true;
        const line1 = lineMy.substring(num1 + strStart.length);

        if (line1.lastIndexOf(strEnd) >= 0) {
            //isAttrPath = false;
        } else {
            result = line1.split(strMiddle);
            //resultat.attrNumber = resultat.arr2.length - 1;
            //arr2.pop();     // remove the last item
        }
    }

    return result;
}

function findAttributeStart(line: string, len: number, constHeight: number) {
    //const delimiterForExpression: string = ',(-+*%/^><= ';     // Symbols, which could be met before Attribute
    const delimiterForExpression: string = ',(-+*%/><= '; // Symbols, which could be met before Attribute
    const delimiterForEntityPath: string = ',(-+*%/><=';

    let startDelimiter = delimiterForExpression;

    if (constHeight != null) {
        startDelimiter = delimiterForEntityPath; //VR; for EntityPath: space " " can be inside Attr, so, it is not DILIMITER;
    }

    let result: string = null;
    let goOut = false;

    // Consider the case: "sin(2) + [Order Details]"
    if (line.lastIndexOf(']') === len) {
        if (line.lastIndexOf('[') >= 0) {
            result = line.substring(line.lastIndexOf('[') + 1, line.lastIndexOf(']')).trim(); // Founded the start of Attribute!
            goOut = true;
        }
    }

    for (let index = len; index >= 0 && goOut == false; index--) {
        const currSymb = line.substr(index, 1);

        if (startDelimiter.indexOf(currSymb) >= 0) {
            result = line.substring(index + 1).trim(); // Founded the start of Attribute!
            goOut = true;
        }
    }

    if ((result != null && result.indexOf('"') >= 0) || (result == null && line.indexOf('"') >= 0)) {
        return -1; // found WRONG symbol
    }

    if (result === '') {
        return -1; // found WRONG symbol
    }

    return result;
}

function getAttributeList(attributes: string[], constHeight: number): string[] {
    const result = [];

    for (let index = attributes.length - 1; index >= 0; index--) {
        const attribute = attributes[index];
        const attributeLastIndex = attribute.length - 1;

        if (attributeLastIndex < 0) {
            // User just type a point here.
            result.unshift('');
        } else if (attribute.indexOf('[') === 0 && attribute.lastIndexOf(']') === attributeLastIndex) {
            // Find square brackets.
            result.unshift(attribute.substring(1, attributeLastIndex).trim()); // if found, it is an Attribute, put it whole w/o brackets.
        } else {
            const num = findAttributeStart(attribute, attributeLastIndex, constHeight);

            if (num === -1) {
                return null; // found WRONG symbol, so: it is NOT attribute
            }

            if (num != null) {
                result.unshift(num); // the start is found, put the cut string as Attribute

                return result; // return the new cut array
            } else {
                result.unshift(attribute); // start not found, it is the whole Attribute
            }
        }
    }

    return result; // 'start' not found (the whole line is Attr??), return the new array
}

function addVaiablesCompleter(langTools, variables: IDisplayValue[]) {
    const scoreVariable = 30; //??

    langTools.addCompleter({
        identifierRegexps: [/@/],
        getCompletions: (
            editor: AceAjax.Editor,
            session: AceAjax.IEditSession,
            pos: AceAjax.Position,
            prefix: string,
            callback: (param, items: IEditorItem[]) => void
        ) => {
            const items = variables.map((variable) => {
                let value = variable.value;

                // prefix === '' when @ is used (see identifierRegexps).
                // In this case drop the first @, because it has been put in already.
                if (prefix === '' && value.startsWith('@')) {
                    value = value.substring(1, value.length);
                }

                const result: IEditorItem = {
                    caption: variable.value,
                    value: value,
                    score: scoreVariable,
                    meta: 'Variable',
                    category: 'Variables',
                    description: variable.displayValue
                };

                return result;
            });

            callback(null, items);
        },

        getDocTooltip: getDocTooltip
    });
}

function addEntitiesCompleter(
    langTools,
    dataSourceID: number,
    isExpression: boolean,
    constHeight: number,
    glob: IGlob
) {
    // Working with ATTRIBUTES list: -----------------------------------
    const scoreEntity = 20;
    const entityList = glob.EntityModelsStore.getEntitiesByDS(dataSourceID);
    const entities: {
        name: string;
        label: string;
        value: string;
        isFunction: boolean;
        meta: string;
        description: string;
        inputParameters: IEditorItem[];
        returnType: string;
    }[] = [];

    entityList?.forEach((entity) => {
        const isScalarFunction = entity.IsScalarFunc;
        const inputParameters: IEditorItem[] = [];

        let meta: string;
        let returnType = ATTRIBUTE_TYPES.ENUMERATION;
        let value = isExpression ? surraundWithBrackets(entity.name) : entity.name;
        let description: string;

        if (isScalarFunction) {
            meta = 'Scalar Function';
        } else {
            meta = 'Entity';
        }

        if (isScalarFunction) {
            const functionAttributes = entity.attributes;

            if (functionAttributes != null) {
                const inputAttrobites: IDataLoadEntityAttribute[] = [];

                value += '(';
                description = '<b>Input Parameter(s):</b>';

                functionAttributes.forEach((parameter) => {
                    if (parameter.input) {
                        inputAttrobites.push({ ...parameter });
                    } else {
                        returnType = parameter.type;
                    }
                });

                inputAttrobites.sort((a, b) => a.order - b.order);

                inputAttrobites.forEach((attribute) => {
                    let parameterDescription = attribute.name + ' - ' + Utilities.explainAttributeType(attribute.type);

                    if (attribute.Nullable) {
                        parameterDescription += ' (nullable)';
                    }

                    description += '</br>' + parameterDescription;

                    inputParameters.push({
                        meta: 'Input Parameter',
                        caption: attribute.name,
                        value: attribute.name,
                        score: scoreEntity,
                        description: parameterDescription,
                        label: attribute.label
                    });
                });
            }
        }

        entities.push({
            meta: meta,
            name: entity.name,
            value: value,
            label: entity.label,
            isFunction: isScalarFunction,
            description: description,
            inputParameters: inputParameters,
            returnType: getAttributeTypeDescription(returnType)
        });
    });

    langTools.addCompleter({
        identifierRegexps: [/[a-zA-Z.(\u005E\[]/], //  [/[a-zA-Z\"\.\u00A2-\uFFFF]/]      //[a-zA-Z\,\"\u00A2-\uFFFF]
        getCompletions: (
            editor: AceAjax.Editor,
            session: AceAjax.IEditSession,
            pos: AceAjax.Position,
            prefix: string,
            callback: (param, items: IEditorItem[]) => void
        ) => {
            let items: string[];
            let attrNumber = 0;
            let isAttrPath = true;

            const line: string = editor.session.getLine(editor.getCursorPosition().row).substring(0, pos.column);

            if (isExpression || constHeight != null) {
                const attributes = line.split(ATTRIBUTE_SEPARATOR);

                if (attributes.length === 1) {
                    const attribute = attributes[0];
                    const attributeLastIndex = attribute.length - 1;

                    if (attributeLastIndex > 0 && attribute[attributeLastIndex] === '(') {
                        const functionName = attribute.substring(0, attributeLastIndex).toLowerCase();
                        const functionEntity = entities.find(
                            (entity) => entity.isFunction && entity.name.toLowerCase() === functionName
                        );

                        if (functionEntity != null) {
                            callback(null, functionEntity.inputParameters);
                        } else {
                            callback(null, []);
                            return;
                        }
                    }
                }

                // For EntityPath: only one string and w/o brackets.
                items = getAttributeList(attributes, constHeight);
            } else {
                items = getAttributeEnvironment(line); // for JSON dialog
            }

            if (items == null) {
                isAttrPath = false;
            } else {
                items.pop();
                attrNumber = items.length;
            }

            // here we are inside the first (or second, or third, ...) ATTRIBUTE:
            if (isAttrPath && attrNumber >= 1) {
                let entityTreeItem = glob.EntityModelsStore.getEntity(items[0], dataSourceID);

                if (attrNumber >= 2) {
                    entityTreeItem = glob.EntityModelsStore.getEntity(items.join('.'), dataSourceID);

                    if (
                        entityTreeItem == null ||
                        entityTreeItem.original == null ||
                        entityTreeItem.original.refer == null
                    ) {
                        callback(null, []);
                        return;
                    }

                    entityTreeItem = glob.EntityModelsStore.getEntity(entityTreeItem.original.refer, dataSourceID);
                }

                if (entityTreeItem != null) {
                    callback(
                        null,
                        entityTreeItem.children.map((child) => {
                            const result: IEditorItem = {
                                caption: child.name,
                                meta: 'Attribute',
                                value: isExpression ? surraundWithBrackets(child.name) : child.name,
                                score: scoreEntity,
                                label: child.original.label,
                                returnType: getAttributeTypeDescription(child.original.type)
                            };

                            return result;
                        })
                    );
                }
                return;
            }

            // here isAttrPath=false OR attrNumber=0, then do usual:
            if (isAttrPath) {
                callback(
                    null,
                    entities.map((entity) => {
                        const result: IEditorItem = {
                            caption: entity.name,
                            meta: entity.meta,
                            value: entity.value,
                            score: scoreEntity,
                            label: entity.label,
                            returnType: entity.returnType,
                            description: entity.description,
                            category: entity.isFunction ? 'SQL Functions' : null
                        };

                        return result;
                    })
                );
            } else {
                callback(null, []);
                return;
            }
        },

        getDocTooltip: getDocTooltip
    });
}

function addFunctionsCompleter(langTools, constHeight: number, glob: IGlob) {
    // Working with SQL FUNCTION list: -----------------------------------
    glob.helpTools.getExpressionSyntax(glob.AppActions).then((wordList: any[]) => {
        const scoreFunction = 10;
        const startDelimiter2 = '0123456789[.@;';

        langTools.addCompleter({
            identifierRegexps: [/0-9/], ///[\+\-\(\ ]/;     [a-zA-Z\+\-\=\s],   [/[a-zA-Z0-9+\[(.]/]
            getCompletions: (
                editor: AceAjax.Editor,
                session: AceAjax.IEditSession,
                pos: AceAjax.Position,
                prefix: string,
                callback: (param, items: IEditorItem[]) => void
            ) => {
                //if (prefix.length === 0) { callback(null, []); return }
                if (prefix.length > 0) {
                    let currSymb = prefix.trim();

                    currSymb = currSymb.substring(currSymb.length - 1, 1);

                    if (startDelimiter2.indexOf(currSymb) >= 0) {
                        callback(null, []);
                        return;
                    }
                }

                const line = editor.session.getLine(editor.getCursorPosition().row).substring(0, pos.column);
                const attributes = line.split(ATTRIBUTE_SEPARATOR);
                const items = getAttributeList(attributes, constHeight);

                if (items != null && items.length > 1) {
                    callback(null, []);
                    return;
                }

                // Show Functions:
                callback(
                    null,
                    wordList.map((item) => {
                        const result: IEditorItem = {
                            caption: item.caption,
                            value: item.value,
                            score: scoreFunction,
                            meta: 'Function',
                            returnType: getAttributeTypeDescription(item.type),
                            syntax: item.syntax,
                            category: item.category,
                            description: item.description
                        };

                        return result;
                    })
                );
            }
        });
    });
}

export default class CodeField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static EditComponent = class extends React.Component<
        {
            value: string;
            wordWrap: boolean;
            setFocus: boolean;
            theme?: any;
            initialHeight?: number; // set height at the first show, then height can be changed while parent resize
            constHeight?: number; // set height as const forewer. it will not be changed while parent resize. "initialHeight" is ignored
            // InteliSense:
            showFuncList?: boolean; // show SQL functions (for Expressions only)
            showAttrList?: boolean; // show Entity model for given DataSourceID
            putAttrAsArray?: boolean; // if "true", then surround Entity or Attr with brackets "[", "]", like [my enttity].attr;
            variables?: IDisplayValue[];
            dataSourceID?: number;
            glob: IGlob;
            onChange?(value: string): void;
        },
        {
            headerHeight?: number;
            height: number;
        }
    > {
        private editor: AceAjax.Editor;
        private handleDocumentChange = _.debounce((e) => {
            this.props.onChange(this.editor.getValue());
        }, 500);

        private references: {
            container?: HTMLDivElement;
            editor?: HTMLDivElement;
        } = {};

        constructor(props) {
            super(props);

            this.state = {
                height: props.constHeight || props.initialHeight || 220
            };
        }

        handleResize(editor, size: { width: number; height: number }) {
            if (
                editor == null ||
                size == null ||
                size.height == null ||
                size.width == null ||
                isNaN(size.height) ||
                isNaN(size.width) ||
                size.height <= 0 ||
                size.width <= 0
            ) {
                return;
            }

            editor.resize(size.width, size.height);
        }

        handleContainerResize = (event, dialogHeight) => {
            const editor = this.references.editor;
            const parent = $(editor).parent();

            if (parent != null && editor != null) {
                let height = dialogHeight; // $(editor).offset().top + 60;
                // This caused endless height decreasing.
                // 98405: The resize of the Expression dialog is frustrating

                if (this.props.constHeight != null) {
                    height = this.props.constHeight;
                }

                const offset = editor != null ? $(editor).offset().top : 0;
                const width = $(parent).offsetParent().width();
                this.handleResize(this.editor, { width: width, height: height - offset });

                if (height != null || !isNaN(height) || height > 0) {
                    this.setState({
                        height: height
                    });
                }
            }
        };

        componentDidMount() {
            const editorNode = this.references.editor;

            require('brace/ext/language_tools');

            const langTools = ace.acequire('ace/ext/language_tools');

            this.editor = ace.edit(editorNode);

            let backgroundColor;

            if (this.props.theme) {
                if (this.props.theme['workspace-bg'] != null) {
                    backgroundColor = this.props.theme['workspace-bg'];
                } else if (this.props.theme['surface-bg'] != null) {
                    backgroundColor = this.props.theme['surface-bg'];
                }
            }

            if (backgroundColor && Utilities.isDark(backgroundColor)) {
                this.editor.setTheme('./theme/ambiance');
            } else {
                this.editor.setTheme('./theme/xcode'); //VR: tomorrow, WAS: chrome, xcode
            }

            this.editor.getSession().setMode('./mode/clojure'); //VR: pgsql,  WAS: javascrip, clojure

            if (this.props.wordWrap != null) {
                this.editor.getSession().setUseWrapMode(this.props.wordWrap);
            }
            //this.editor.getSession().highlight('ID');

            if (this.props.setFocus) {
                this.editor.focus();
            }

            this.editor.setValue(this.props.value);
            this.editor.clearSelection();
            this.editor.scrollPageUp();

            this.editor.resize(true);
            this.editor.setShowPrintMargin(false);
            this.editor.moveCursorToPosition({ row: 0, column: 0 });
            //this.editor.setOption("maxLines", Infinity);

            if (typeof this.props.onChange === 'function') {
                this.editor.addEventListener('change', _.bind(this.handleDocumentChange, this));
            }

            langTools.setCompleters([]);

            if (this.props.variables?.length > 0) {
                addVaiablesCompleter(langTools, this.props.variables);
            }

            if (this.props.dataSourceID != null && this.props.showAttrList) {
                addEntitiesCompleter(
                    langTools,
                    this.props.dataSourceID,
                    this.props.putAttrAsArray,
                    this.props.constHeight,
                    this.props.glob
                );
            }

            if (this.props.showFuncList) {
                addFunctionsCompleter(langTools, this.props.constHeight, this.props.glob);
            }

            this.editor.setOptions({
                enableBasicAutocompletion: true,
                enableSnippets: false,
                enableLiveAutocompletion: true
            });

            const container = this.references.container;

            $(container).on('container-resize', this.handleContainerResize);

            const modalBody = $(container).closest('.modal-body');
            const height = $(modalBody).height();

            if (this.props.constHeight == null) {
                //VR: property "constHeight" is for Entity Path, there "overflow" should be!
                $(modalBody).css('overflow', 'hidden');
            }

            //this.handleContainerResize(null, height);
        }

        componentDidUpdate(prevProps, prevState) {
            if (this.state.height !== prevState.height) {
                const height = this.state.height;
                const width = $(parent).offsetParent().width();

                const editor = this.references.editor;
                const offset = editor != null ? $(editor).offset().top : 0;

                this.handleResize(this.editor, { width: width, height: height - offset });
            }
        }

        componentWillUnmount() {
            const container = this.references.container;

            this.editor.destroy();
            $(container).off('container-resize', this.handleContainerResize);
        }

        render() {
            //VR: only for EntityPath editor: clear the value before entering a new value;
            if (this.editor != null && this.props.constHeight != null) {
                const oldValue = this.editor.getValue();

                if (this.props.value != oldValue) {
                    this.editor.setValue(this.props.value);
                }
            }

            const editor = this.references.editor;

            let height = this.state.height;
            if (editor != null) {
                height = height - $(editor).offset().top + 60;
            }

            return (
                <div
                    ref={(input) => {
                        this.references.container = input;
                    }}
                    className="listen-container-resize"
                    style={{ height: this.state.height + 'px' }}
                >
                    <div
                        ref={(input) => {
                            this.references.editor = input;
                        }}
                        style={{
                            height: height + 'px',
                            width: '100%',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            borderColor: 'lightgray'
                        }}
                    ></div>
                </div>
            );
        }
    };

    constructor(glob: IGlob, title: string, validators?: any[], defaultVal?, options?) {
        super(glob, title, [], validators, defaultVal, options);
    }
}
